/** Normalize a guest root path to manifest form (no leading/trailing slashes). Empty = whole folder. */
export function normalizeGuestRootPath(path: string | null | undefined): string {
  if (!path) {
    return '';
  }

  return path
    .replace(/\\/g, '/')
    .split('/')
    .map((part) => part.trim())
    .filter((part) => part.length > 0 && part !== '.' && part !== '..')
    .join('/');
}

export function isPathWithinGuestRoot(path: string, rootPath: string): boolean {
  const root = normalizeGuestRootPath(rootPath);
  if (!root) {
    return true;
  }

  return path === root || path.startsWith(`${root}/`);
}

export function clampPathToGuestRoot(path: string, rootPath: string): string {
  const root = normalizeGuestRootPath(rootPath);
  if (!root) {
    return path.replace(/^\/+|\/+$/g, '');
  }

  const normalized = path.replace(/^\/+|\/+$/g, '');
  if (!isPathWithinGuestRoot(normalized, root)) {
    return root;
  }

  return normalized;
}

export function guestRelativePath(absolutePath: string, rootPath: string): string {
  const root = normalizeGuestRootPath(rootPath);
  if (!root) {
    return absolutePath;
  }

  if (absolutePath === root) {
    return '';
  }

  if (absolutePath.startsWith(`${root}/`)) {
    return absolutePath.slice(root.length + 1);
  }

  return absolutePath;
}
